import { gql } from '@apollo/client';

import { subjectsTreeFragment } from '../fragments';

export default gql`
  mutation ToggleSubjectStatus($courseId: String!, $subjectId: String!, $status: String!) {
    subject(courseId: $courseId, subjectId: $subjectId, status: $status, input: {})
      @rest(type: "Subject", path: "courses/{args.courseId}/subjects/{args.subjectId}/{args.status}", method: "PUT") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
